import { Currency } from '../bank-account/bank-account';
import { EmployeeGlAccountKey } from '../employee-account/employee-account';

/** Mirrors Finance.Models FundMovementType; only the opening exists (#5786). */
export enum FundMovementType {
  Opening = 1,
}

/** Mirrors Finance.Models FundMovementStatus. */
export enum FundMovementStatus {
  Draft = 1,
  Posted = 2,
}

export interface FundMovementKey {
  reference: string;
  number: string;
  entityDefinitionCode: number;
}

export interface FundMovementAttachment {
  name: string;
  presignedUrl: string;
}

/** Cash from the bank into a petty cash fund (#5786) — mirrors Finance.Models FundMovementDto. */
export interface FundMovement {
  id: string;
  /** e.g. NT-FMOV-2026-000001 */
  number: string;
  financialCompanyReference: string;
  fund: FundMovementKey;
  type: FundMovementType;
  currency: Currency;
  amount: number;
  movementDate: string;
  /** Stamped when posted: currency → functional multiplier, the USD quote, and the amount in both. */
  exchangeRate: number;
  rateToUsd: number | null;
  functionalCurrency: Currency;
  functionalAmount: number | null;
  amountUsd: number | null;
  bankAccountReference: string | null;
  bankingReference: string | null;
  transferFee: number;
  securityTax: number;
  note: string | null;
  attachments: FundMovementAttachment[];
  fundGlAccount: EmployeeGlAccountKey | null;
  bankGlAccount: EmployeeGlAccountKey | null;
  journalEntryReference: string | null;
  journalEntryNumber: string | null;
  bankTransactionReference: string | null;
  bankTransactionNumber: string | null;
  status: FundMovementStatus;
  createdBy: string | null;
  createdDate: string | null;
}

/** What the treasurer sends for a Draft movement. */
export interface FundMovementUpdate {
  amount: number;
  /** yyyy-MM-dd */
  movementDate: string;
  bankAccountReference: string | null;
  bankingReference: string | null;
  transferFee: number;
  securityTax: number;
  note: string | null;
}

/** A bank account that may fund the fund: active, same company and currency, open to Petty Cash. */
export interface FundingBankAccount {
  reference: string;
  code: string | null;
  name: string;
  bankName: string;
  bankAccountNumber: string;
  currency: Currency;
}
